import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFormatItalic = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M10,4V7H12.21L8.79,15H6V18H14V15H11.79L15.21,7H18V4H10Z"
	})
});
export default SvgFormatItalic;
